import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right\">\n<path d=\"M13 10.375L13.875 11.25L13 12.125L9.625 15.5L8.75 14.5L12.125 11.125L8.75 7.875L9.625 7L13 10.375ZM10.625 21.75C4.75 21.75 0 17 0 11.125C0 5.25 4.75 0.5 10.625 0.5C16.5 0.5 21.25 5.25 21.25 11.125C21.25 17 16.5 21.75 10.625 21.75ZM10.625 20.5C15.75 20.5 20 16.25 20 11.125C20 6 15.75 1.75 10.625 1.75C5.5 1.75 1.25 6 1.25 11.125C1.25 16.25 5.5 20.5 10.625 20.5Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-right.svg
// module id = dxdv
// module chunks = 111